import { render, staticRenderFns } from "./yujianfenzhenUser.vue?vue&type=template&id=4a0689bb&scoped=true"
import script from "./yujianfenzhenUser.vue?vue&type=script&lang=js"
export * from "./yujianfenzhenUser.vue?vue&type=script&lang=js"
import style0 from "./yujianfenzhenUser.vue?vue&type=style&index=0&id=4a0689bb&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0689bb",
  null
  
)

export default component.exports